module.exports = __webpack_public_path__ + "static/media/46_tn.f547368f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/46_tn.jpg
// module id = 534
// module chunks = 0